<header class="public-header">
  <button class="btn btn-ghost btn-sm public-header-back" (click)="goBack()">
    <app-icon name="arrow-left" [size]="14"></app-icon>
    Back
  </button>
  <a routerLink="/layout/dashboard" class="public-header-logo">
    <img src="assets/images/dairector-logo.svg" alt="dAIrector" />
  </a>
</header>

<div class="legal-page">
  <div class="legal-container">
    <p class="legal-intro">
      This Privacy Policy describes how High Giraffe Media Pvt Ltd ("dAIrector", "we", "us", or "our")
      collects, uses, and protects information when you access or use the dAIrector platform.
    </p>

    <section class="legal-section">
      <div class="section-header">
        <span class="section-number">01</span>
        <h2 class="section-title">Scope of This Policy</h2>
      </div>
      <div class="section-content">
        <p>
          This Privacy Policy applies to all users of the dAIrector platform, including individual
          users, collaborators, and organizations. It covers information collected through the
          platform, associated services, and communications.
        </p>
      </div>
    </section>

    <section class="legal-section">
      <div class="section-header">
        <span class="section-number">02</span>
        <h2 class="section-title">Information We Collect</h2>
      </div>
      <div class="section-content">
        <p>We collect information necessary to operate and deliver the platform, including:</p>

        <div class="subsection">
          <h3 class="subsection-title">Account and Organization Information</h3>
          <ul class="legal-list">
            <li>Name, email address, and authentication credentials</li>
            <li>Organization names and membership details</li>
            <li>Role and permission settings</li>
          </ul>
        </div>

        <div class="subsection">
          <h3 class="subsection-title">Project and Usage Data</h3>
          <ul class="legal-list">
            <li>Project metadata, configuration settings, and workflow states</li>
            <li>Uploaded assets and references</li>
            <li>System-generated metadata required to execute production workflows</li>
          </ul>
        </div>

        <div class="subsection">
          <h3 class="subsection-title">Technical and Usage Information</h3>
          <ul class="legal-list">
            <li>Log data, device information, and usage telemetry</li>
            <li>Security and performance monitoring data</li>
          </ul>
        </div>
      </div>
    </section>

    <section class="legal-section">
      <div class="section-header">
        <span class="section-number">03</span>
        <h2 class="section-title">Information We Do Not Use</h2>
      </div>
      <div class="section-content">
        <div class="highlight-box important">
          <p>
            We do <strong>not</strong>:
          </p>
          <ul class="legal-list">
            <li>Use your inputs or outputs to train AI models</li>
            <li>Reuse or resell your data or generated outputs</li>
            <li>Share your content across organizations or tenants</li>
          </ul>
        </div>
        <p>
          All user data remains isolated within the originating organization.
        </p>
      </div>
    </section>

    <section class="legal-section">
      <div class="section-header">
        <span class="section-number">04</span>
        <h2 class="section-title">How We Use Information</h2>
      </div>
      <div class="section-content">
        <p>We use collected information solely to:</p>
        <ul class="legal-list">
          <li>Provide, operate, and maintain the platform</li>
          <li>Enable collaboration and workflow execution</li>
          <li>Secure the platform and prevent misuse</li>
          <li>Provide customer support and communicate service-related updates</li>
        </ul>
      </div>
    </section>

    <section class="legal-section">
      <div class="section-header">
        <span class="section-number">05</span>
        <h2 class="section-title">Third-Party Services</h2>
      </div>
      <div class="section-content">
        <p>
          dAIrector relies on trusted third-party providers for infrastructure and AI
          capabilities, including generative and language models.
        </p>
        <p>
          We share only the minimum necessary data required for these services to function and do
          not permit third parties to use your data for their own purposes.
        </p>
      </div>
    </section>

    <section class="legal-section">
      <div class="section-header">
        <span class="section-number">06</span>
        <h2 class="section-title">Data Security and Isolation</h2>
      </div>
      <div class="section-content">
        <p>
          We implement reasonable technical and organizational safeguards designed to protect user
          data, including:
        </p>
        <ul class="legal-list">
          <li>Logical separation of organizational data</li>
          <li>Access controls based on user roles</li>
          <li>Monitoring for unauthorized access or misuse</li>
        </ul>
        <p>
          While no system can guarantee absolute security, we take data protection seriously and
          continuously improve our safeguards.
        </p>
      </div>
    </section>

    <section class="legal-section">
      <div class="section-header">
        <span class="section-number">07</span>
        <h2 class="section-title">Data Retention and Deletion</h2>
      </div>
      <div class="section-content">
        <p>
          Data is retained only for as long as necessary to provide the service or as required by
          applicable law.
        </p>
        <p>
          Upon deletion of a project or organization, associated data will be deleted or rendered
          inaccessible within a reasonable period, subject to backup and compliance requirements.
        </p>
      </div>
    </section>

    <section class="legal-section">
      <div class="section-header">
        <span class="section-number">08</span>
        <h2 class="section-title">User Rights</h2>
      </div>
      <div class="section-content">
        <p>
          Depending on applicable law, you may have the right to:
        </p>
        <ul class="legal-list">
          <li>Access your personal data</li>
          <li>Request correction or deletion</li>
          <li>Withdraw consent where applicable</li>
        </ul>
        <p>
          Requests may be submitted via the contact details below.
        </p>
      </div>
    </section>

    <section class="legal-section">
      <div class="section-header">
        <span class="section-number">09</span>
        <h2 class="section-title">Governing Law</h2>
      </div>
      <div class="section-content">
        <p>
          This Privacy Policy is governed by the laws of India.
        </p>
      </div>
    </section>

    <section class="legal-section">
      <div class="section-header">
        <span class="section-number">10</span>
        <h2 class="section-title">Updates to This Policy</h2>
      </div>
      <div class="section-content">
        <p>
          We may update this Privacy Policy periodically. Material changes will be communicated
          through the platform or via email.
        </p>
      </div>
    </section>

    <section class="legal-section">
      <div class="section-header">
        <span class="section-number">11</span>
        <h2 class="section-title">Contact</h2>
      </div>
      <div class="section-content">
        <p>
          For privacy-related questions or requests, please contact:
          <a href="mailto:privacy@dairector.ai" class="contact-email">privacy@dairector.ai</a>
        </p>
      </div>
    </section>
  </div>
</div>

<footer class="public-footer">
  <div class="public-footer-inner">
    <img src="assets/images/dairector-logo.svg" alt="dAIrector" class="public-footer-logo" />
    <div class="public-footer-links">
      <a routerLink="/privacy-policy" class="public-footer-link">Privacy Policy</a>
      <span class="public-footer-sep">·</span>
      <a routerLink="/terms-of-service" class="public-footer-link">Terms of Service</a>
      <span class="public-footer-sep">·</span>
      <a routerLink="/help-center" class="public-footer-link">Help Center</a>
    </div>
    <div class="public-footer-copy">© 2025 High Giraffe Media Pvt Ltd. All rights reserved.</div>
  </div>
</footer>
